export const getSellerUrl = (seller) => {

    if(seller && seller.stateName && seller.city && seller.seoName && seller.isProfilePublished){
        const state = seller.stateName.replace(/ |\//g, '-').toLowerCase();
        const city = seller.city.replace(/ |\//g, '-').toLowerCase();

        return `/business/${state}/${city}/${seller.seoName}`
    }

    return null;
    
}